import { ParamIds, Places } from '../../../Constants'
import IntegracaoMonitoramentoKeys from '../integracao-monitoramento.keys'

export class ResultadoAnaliseVisaoCedenteKeys extends IntegracaoMonitoramentoKeys {
    get place() {
        return Places.resultadoAnaliseVisaoCedente
    }

    get visaoCedenteId() {
        return this._intent.getParameterAsNumber(ParamIds.resultVisaoCedenteId)
    }

    set visaoCedenteId(value: number | undefined) {
        this._intent.setParameter(ParamIds.resultVisaoCedenteId, value)
    }
}
